import script from "./PaperDetailsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperDetailsDialog.vue?vue&type=script&setup=true&lang=js"

import "./PaperDetailsDialog.vue?vue&type=style&index=0&id=7d7f60a7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d7f60a7"]])

export default __exports__